import { type FC, memo } from 'react';
import styles from './index.module.scss';
import { Drawer, type DrawerProps } from 'antd';

interface OwnProps extends DrawerProps {}

const ParrotDrawer: FC<OwnProps> = ({ children, ...props }) => {
  return (
    <Drawer
      width={'100%'}
      height={'80%'}
      placement="bottom"
      className={styles.parrot_drawer}
      maskClosable={false}
      {...props}
    >
      {props.open ? children : undefined}
    </Drawer>
  );
};

export default memo(ParrotDrawer);
